import { render } from "./OtelloButton.vue?vue&type=template&id=7a63e5fe"
import script from "./OtelloButton.vue?vue&type=script&lang=js"
export * from "./OtelloButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__